type RealtimeVoiceNavigationTarget = {
  orgSlug: string;
  routeRef: string;
};

let pendingTarget: RealtimeVoiceNavigationTarget | null = null;

function targetsMatch(
  left: RealtimeVoiceNavigationTarget,
  right: RealtimeVoiceNavigationTarget
): boolean {
  return left.orgSlug === right.orgSlug && left.routeRef === right.routeRef;
}

export function setRealtimeVoiceNavigationIntent(
  target: RealtimeVoiceNavigationTarget
): void {
  pendingTarget = target;
}

export function peekRealtimeVoiceNavigationIntent(
  target: RealtimeVoiceNavigationTarget
): boolean {
  return pendingTarget !== null && targetsMatch(pendingTarget, target);
}

export function consumeRealtimeVoiceNavigationIntent(
  target: RealtimeVoiceNavigationTarget
): boolean {
  if (!peekRealtimeVoiceNavigationIntent(target)) return false;
  pendingTarget = null;
  return true;
}
